// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paginationStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListPagination";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

paginationStyles.pagination = {
    selectProps: {
        labelProps: {
            weight: fontConfig.weight.regular,
            css: css`
                line-height: ${fontConfig.lineHeight.small};
                padding-top: 0;
                padding-right: 8px;
            `,
        },
    },
    cssOverrides: {
        perPageSelect: css`
            align-items: center;
        `,
    },
};
